export const TOKEN_SEARCH_REQUEST = 'TOKEN_SEARCH_REQUEST';
export const TOKEN_SEARCH_SUCCESS = 'TOKEN_SEARCH_SUCCESS';
export const TOKEN_SEARCH_ERROR = 'TOKEN_SEARCH_ERROR';

export const RESEARCH_FEED_REQUEST = 'RESEARCH_FEED_REQUEST';
export const RESEARCH_FEED_SUCCESS = 'RESEARCH_FEED_SUCCESS';
export const RESEARCH_FEED_ERROR = 'RESEARCH_FEED_ERROR';